export const communicationKitQueryKeys = {
  all: ["communication-kits"] as const,
  me: () => [...communicationKitQueryKeys.all, "me"] as const,
  get: (id: string) => [...communicationKitQueryKeys.all, "get", id] as const,
};
